var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование Склада","resource":"warehouses","elements":_vm.elements,"add-message":"Склад добавлен","edit-message":"Склад изменен"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }